import React from 'react';
import { Section } from './ui/Section';
import { Clock, Frown, Smartphone } from 'lucide-react';
export function ProblemSection() {
  return <Section bg="cream" data-id="element-178">
      <h2 className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-179">
        ¿Te suena familiar esta historia? 🥣
      </h2>

      <div className="grid md:grid-cols-3 gap-8" data-id="element-180">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#F59E0B]/20" data-id="element-181">
          <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4 text-[#EA580C]" data-id="element-182">
            <Clock size={24} data-id="element-183" />
          </div>
          <p className="text-[#78350F] leading-relaxed" data-id="element-184">
            Cada noche es una carrera contra el reloj. Los niños preguntan “¿qué
            hay de cenar?” justo cuando tú apenas te quitas los zapatos.
          </p>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#F59E0B]/20" data-id="element-185">
          <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4 text-[#EA580C]" data-id="element-186">
            <Smartphone size={24} data-id="element-187" />
          </div>
          <p className="text-[#78350F] leading-relaxed" data-id="element-188">
            Abrir apps de delivery se ha vuelto costumbre, pero te hace sentir
            culpable y drena tu presupuesto semanal.
          </p>
        </div>

        <div className="bg-white p-6 rounded-2xl shadow-sm border border-[#F59E0B]/20" data-id="element-189">
          <div className="w-12 h-12 bg-[#FFF8F0] rounded-full flex items-center justify-center mb-4 text-[#EA580C]" data-id="element-190">
            <Frown size={24} data-id="element-191" />
          </div>
          <p className="text-[#78350F] leading-relaxed" data-id="element-192">
            Has probado meal prep el domingo, pero entre el lavado de ollas, los
            toppers y la falta de tiempo, terminas agotada antes de que empiece
            la semana. Y cuando intentas recalentar lo mismo tres días seguidos,
            los niños se quejan de que siempre es igual.
          </p>
        </div>
      </div>
    </Section>;
}